import React, {useEffect, useRef, useState} from 'react';
import {Box, Button, CssVarsProvider, Sheet, Stack} from '@mui/joy';
import {ProjectRepository} from './../repository/ProjectRepository';
import LoadingPage from "./Loading";
import TimeOutPage from "./TimeOut";
function ResumePage() {
    const repo = new ProjectRepository()
    const [resumeURL, setResumeURL] = useState<string>('');
    const resumeRef = useRef(null)
    const [error, setError] = useState<boolean>(false);

    function downloadResume() {
        let element = document.createElement("a");
        element.href = resumeURL;
        element.download='Monney Fetchner Developer.pdf';
        element.click();
    }
    useEffect(() => {
        repo.getResumeURL().then((value: string) => {
            if (value.length > 0) {
                setResumeURL(value);
                downloadResume();
            }
        }).catch(reason => setError(true));
    })
    return (
        <Box paddingTop={2} paddingX={{xs:2, md:6,}} sx={{bgcolor:'background.surface'}}>
            {!(resumeURL.length > 0) && (
                <LoadingPage/>
            )}
            {(resumeURL.length > 0 && error) && (
                <TimeOutPage/>
            )}
            {(resumeURL.length > 0 && !error) && (
            <Sheet sx={{height: '100vh', paddingX: 4, paddingY: 2, alignItems: 'center', justifyContent: 'center'}}>
            <Stack justifyContent={{md: "start", xs: "center"}} direction="row" spacing={2}>
                <a download ='Monney Fetchner Developer.pdf' href={resumeURL}><Button>Download Resume</Button></a>
            </Stack>
        </Sheet>
                )}
        </Box>
    );
}

export default ResumePage;
